/* eslint-disable lines-around-comment */
import { withStyles } from '@material-ui/styles';
import React, { Component } from 'react';
import { batch, connect } from 'react-redux';
import { isMobileBrowser } from '../../../base/environment/utils';
// @ts-ignore
import { translate } from '../../../base/i18n';
import { IconHorizontalPoints } from '../../../base/icons/svg';
import { getParticipantById } from '../../../base/participants/functions';
// @ts-ignore
import { Popover } from '../../../base/popover';
// @ts-ignore
import { setParticipantContextMenuOpen } from '../../../base/responsive-ui/actions';
import Button from '../../../base/ui/components/web/Button';
import ConnectionIndicatorContent from 
// @ts-ignore
'../../../connection-indicator/components/web/ConnectionIndicatorContent';
import { THUMBNAIL_TYPE } from '../../../filmstrip/constants';
// @ts-ignore
import { renderConnectionStatus } from '../../actions.web';
// @ts-ignore
import ParticipantContextMenu from './ParticipantContextMenu';
// @ts-ignore
import { REMOTE_CONTROL_MENU_STATES } from './RemoteControlButton';
const styles = () => {
    return {
        triggerButton: {
            padding: '3px !important',
            borderRadius: '4px'
        },
        contextMenu: {
            position: 'relative',
            marginTop: 0,
            right: 'auto',
            padding: '0',
            marginRight: '4px',
            marginBottom: '4px'
        }
    };
};
/**
 * React {@code Component} for displaying an icon associated with opening the
 * the {@code VideoMenu}.
 *
 * @augments {Component}
 */
class RemoteVideoMenuTriggerButton extends Component {
    /**
     * Initializes a new RemoteVideoMenuTriggerButton instance.
     *
     * @param {Object} props - The read-only React Component props with which
     * the new instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this._onPopoverClose = this._onPopoverClose.bind(this);
        this._onPopoverOpen = this._onPopoverOpen.bind(this);
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _disabled, _overflowDrawer, _showConnectionInfo, _participantDisplayName, buttonVisible, classes, participantID, popoverVisible } = this.props;
        let content;
        if (_showConnectionInfo) {
            content = React.createElement(ConnectionIndicatorContent, { participantId: participantID });
        }
        else if (!_disabled) {
            content = this._renderRemoteVideoMenu();
        }
        if (!content) {
            return null;
        }
        const username = _participantDisplayName;
        return (React.createElement(Popover, { content: content, id: 'remote-video-menu-trigger', onPopoverClose: this._onPopoverClose, onPopoverOpen: this._onPopoverOpen, position: this.props._menuPosition, visible: popoverVisible }, !_overflowDrawer && buttonVisible && !_disabled && (!isMobileBrowser() && React.createElement(Button, { accessibilityLabel: this.props.t('dialog.remoteUserControls', { username }), className: classes.triggerButton, icon: IconHorizontalPoints, size: 'small' }))));
    }
    /**
     * Disable and hide toolbox while context menu is open.
     *
     * @returns {void}
     */
    _onPopoverOpen() {
        const { dispatch, showPopover } = this.props;
        showPopover();
        dispatch(setParticipantContextMenuOpen(true));
    }
    /**
     * Render normal context menu next time popover dialog opens.
     *
     * @returns {void}
     */
    _onPopoverClose() {
        const { dispatch, hidePopover } = this.props;
        hidePopover();
        batch(() => {
            dispatch(setParticipantContextMenuOpen(false));
            dispatch(renderConnectionStatus(false));
        });
    }
    /**
     * Creates a new {@code VideoMenu} with buttons for interacting with
     * the remote participant.
     *
     * @private
     * @returns {ReactElement}
     */
    _renderRemoteVideoMenu() {
        const { _participant, _remoteControlState, classes } = this.props;
        return (React.createElement(ParticipantContextMenu, { className: classes.contextMenu, onSelect: this._onPopoverClose, participant: _participant, remoteControlState: _remoteControlState, thumbnailMenu: true }));
    }
}
/**
 * Maps (parts of) the Redux state to the associated {@code RemoteVideoMenuTriggerButton}'s props.
 *
 * @param {Object} state - The Redux state.
 * @param {Object} ownProps - The own props of the component.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state, ownProps) {
    var _a, _b;
    const { participantID, thumbnailType } = ownProps;
    let _remoteControlState = null;
    const participant = getParticipantById(state, participantID !== null && participantID !== void 0 ? participantID : '');
    const _participantDisplayName = participant === null || participant === void 0 ? void 0 : participant.name;
    const _isRemoteControlSessionActive = (_a = participant === null || participant === void 0 ? void 0 : participant.remoteControlSessionStatus) !== null && _a !== void 0 ? _a : false;
    const _supportsRemoteControl = (_b = participant === null || participant === void 0 ? void 0 : participant.supportsRemoteControl) !== null && _b !== void 0 ? _b : false;
    const { active, controller } = state['features/remote-control'];
    const { requestedParticipant, controlled } = controller;
    const activeParticipant = requestedParticipant || controlled;
    const { overflowDrawer } = state['features/toolbox'];
    const { showConnectionInfo } = state['features/base/connection'];
    const { remoteVideoMenu } = state['features/base/config'];
    if (_supportsRemoteControl
        && ((!active && !_isRemoteControlSessionActive) || activeParticipant === participantID)) {
        if (requestedParticipant === participantID) {
            _remoteControlState = REMOTE_CONTROL_MENU_STATES.REQUESTING;
        }
        else if (controlled) {
            _remoteControlState = REMOTE_CONTROL_MENU_STATES.STARTED;
        }
        else {
            _remoteControlState = REMOTE_CONTROL_MENU_STATES.NOT_STARTED;
        }
    }
    let _menuPosition;
    switch (thumbnailType) {
        case THUMBNAIL_TYPE.TILE:
            _menuPosition = 'left-start';
            break;
        case THUMBNAIL_TYPE.VERTICAL:
            _menuPosition = 'left-end';
            break;
        case THUMBNAIL_TYPE.HORIZONTAL:
            _menuPosition = 'top';
            break;
        default:
            _menuPosition = 'auto';
    }
    return {
        _disabled: remoteVideoMenu === null || remoteVideoMenu === void 0 ? void 0 : remoteVideoMenu.disabled,
        _menuPosition,
        _overflowDrawer: overflowDrawer,
        _participant: participant,
        _participantDisplayName,
        _remoteControlState,
        _showConnectionInfo: showConnectionInfo
    };
}
export default translate(connect(_mapStateToProps)(
// @ts-ignore
withStyles(styles)(RemoteVideoMenuTriggerButton)));
